import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { IOperative } from '../../../message-models/operative.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { IBreadcrumb } from '../../../eca-breadcrumb/models/breadcrumb.interface';
import { EcaBreadcrumbService } from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import { DetailContainerComponent } from '../../../common/components/detail-container/detail-container.component';
import { OurUserService } from '../../../users/services/user.service';
import { IAllowedOperations, IUserInfo } from '../../../users/models/userInfo.interface';
import { consts } from '../../../common/modals/consts';
import { Subscription } from 'rxjs';
import { EcaConfirmProcessService } from '../../../shared/services/eca-confirm-process.service';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { AlertsService } from '../../../alerts/services/alerts.service';
import { HelpConsts } from '../../../help/models/help-consts';
import { HelpModalService } from '../../../help/services/help-modal.service';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';
import { CompanyJobRoleService } from '../../../setting/job-role/services/company-job-role.service';
import { CompanyJobTitle } from '../../../message-models/company-job-title.class';
import { CompanyJobRoleModalService } from '../../../setting/job-role/services/company-job-role-modal.service';
import { EcaConfirmDeleteModalOptions } from '../../../shared/models/confirm-delete-modal-options.class';
import { ListDataService } from '../../../services/list-data.service';

@Component({
  selector: 'app-company-settings-page-details',
  templateUrl: './company-settings-page.component.html',
  styleUrls: ['./company-settings-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CompanySettingsPageComponent implements OnInit {y
  editingDetails: boolean; 
  loggedInUserSubscription: Subscription;
  companyJobTitles: ICompanyJobTitle[] = [];
  jobTitlesLoaded: boolean = true;
  loggedInUser: IUserInfo;
  private companyId: string = consts.emptyGuid;
  private subscription: Subscription;
  public CompanySettingOperations: IAllowedOperations = {} as IAllowedOperations;
  // originalTrainingRecord: TrainingRecord = new TrainingRecord({} as ITrainingRecord);

  constructor(private route: ActivatedRoute,
    private helpService: HelpModalService,
    private ecaBreadcrumbService: EcaBreadcrumbService,
    private confirmProcessService: EcaConfirmProcessService,
    private alertsService: AlertsService,
    private userService: OurUserService,
    private router: Router,
    private companyJobRoleService: CompanyJobRoleService,
    private listDataService: ListDataService,
    private companyJobRoleModalService: CompanyJobRoleModalService,
    private errorHandlingService: ErrorHandlingService) {
  }
  ngOnInit(): void {
  
    this.userService.getLoggedInUser().subscribe(user => {
      //this.updateUserAndReload(user);
      this.subscription = this.userService.getLoggedInUserSubject().subscribe(user => {

        

        this.updateUserAndReload(user);
      })
      this.populateBreadcrumbs();
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
 
  }

  private updateUserAndReload(user: IUserInfo) {
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
    if (this.companyId !== consts.emptyGuid && this.companyId !== undefined) {
      this.CompanySettingOperations = {
        canInsert: true,
        canUpdate: true,
        canRetrieve: true,
        canDelete: true
      } as IAllowedOperations;

      this.getAllCompanyJobTitles();
    }
    this.populateBreadcrumbs();
  }

  private populateBreadcrumbs() {
    const companySettingsBreadCrumbs = new Array<IBreadcrumb>();
    companySettingsBreadCrumbs.push({ label: 'Company Settings', iconName: 'users', routeLink: '/company-settings' } as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(companySettingsBreadCrumbs);
  }


  getAllCompanyJobTitles() {
 
    this.companyJobRoleService.getCompanyJobTitlesByCompanyId(this.companyId).subscribe(listResut => {
    
      this.companyJobTitles = [];
      listResut?.forEach(r => this.companyJobTitles.push(r));
      this.jobTitlesLoaded = false;
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    });
  }

  addNewCompanyJobRole() {
    const newCompanyJobTitle = new CompanyJobTitle();
    newCompanyJobTitle.name = "";
    newCompanyJobTitle.companyId = this.companyId;
    newCompanyJobTitle.defaultJobLevelId = "F98C9737-8A67-44EB-947C-ACFA010EF3A6";
    newCompanyJobTitle.operativeTypeId = "4EFF2451-6793-4590-82C1-FC189DC47859";
    newCompanyJobTitle.electricalWorkType = 1;
    newCompanyJobTitle.createdBy = this.loggedInUser.userName;
    newCompanyJobTitle.updatedBy = newCompanyJobTitle.createdBy;

    this.companyJobRoleModalService.openCompanyJobTitleEditorModal(
      "Add new Company Job Role for Non electrician ",
      true,
      newCompanyJobTitle).subscribe(modalRef => {
        modalRef.content.cancelCompanyJobTitleClicked.subscribe(result => {
          this.companyJobRoleModalService.companyJobTitleEditorModalRef.dynamicDialogRef.close();
        });
        modalRef.content.saveCompanyJobTitleClicked.subscribe(companyJobTitle => {
          console.log(companyJobTitle);
          this.companyJobRoleModalService.companyJobTitleEditorModalRef.dynamicDialogRef.close();
          this.companyJobRoleService.CreateOrUpdateCompanyJobTitle(companyJobTitle).subscribe(companyJobRole => {
            this.getAllCompanyJobTitles();
            //This will trigger any component that is suscribed to this event.
            this.listDataService.updateLists();
          }, () => {
            this.errorHandlingService.showErrorWarning().subscribe(() => {
            });
          });
        });
      });
  }



  deleteCompanyJobTitle(companyJobTitle: CompanyJobTitle) {
    this.confirmProcessService.openConfirmProcessModal('<p>Are you SURE you want to remove this job title?</p>','Remove Company Job Title'
      , new EcaConfirmDeleteModalOptions()).subscribe({
        next: response => {
          if (response) {
            this.companyJobRoleService.RemoveCompanyJobTitle(companyJobTitle).subscribe(result => {
              this.getAllCompanyJobTitles();
              //This will trigger any component that is suscribed to this event.
              this.listDataService.updateLists();
            }, () => {
              this.errorHandlingService.showErrorWarning().subscribe(() => {
                // this.router.navigateByUrl('/dashboard');
              });
            });
          }
        }
      });
  }
}
